import { gql } from '@apollo/client';

export const COGNITO_STATE_FRAGMENT = gql`
  fragment CognitoStateFragment on UserCognitoState {
    __typename
    status
    cognitoUsers {
      email {
        ...CognitoUserFragment
      }
      phone {
        ...CognitoUserFragment
      }
    }
  }

  fragment CognitoUserFragment on CognitoStateUser {
    attributes {
      name
      value
    }
    groups
    status
  }
`;

export const GET_USER_COGNITO_STATE = gql`
  query GetUserCognitoState($id: ID!) {
    userCognitoState(id: $id) {
      ...CognitoStateFragment
      ... on NotFoundError {
        message
        responseType
        __typename
      }
      ... on AuthorizationFailure {
        message
        responseType
        __typename
      }
      __typename
    }
  }

  ${COGNITO_STATE_FRAGMENT}
`;
